var _style, _g, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKdg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1014.5 133.9",
    style: {
      enableBackground: "new 0 0 1014.5 133.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:url(#SVGID_2_);}\r\n\t.st4{fill:url(#SVGID_3_);}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.5,39.4V102h7.8V85.7l12.4-14.1l21.1,30.3h9.3l-24.7-36.2l22.9-26.4h-9.5l-31.5,35.6V39.4H396.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459.6,40.1c-0.9-0.9-2.1-1.3-3.4-1.3c-1.4,0-2.5,0.4-3.4,1.3s-1.3,2.1-1.3,3.4c0,1.4,0.4,2.5,1.3,3.4 s2,1.3,3.4,1.3c1.3,0,2.5-0.4,3.4-1.3s1.3-2,1.3-3.4C460.9,42.2,460.5,41,459.6,40.1z M452.5,56.4V102h7.3V56.4H452.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M505.6,60.9c-3.4-3.3-7.8-5-13.3-5c-6.6,0-11.6,2.2-15,6.7l-1-6.2h-6.4V102h7.3V79.2c0-5.1,1.2-9.1,3.7-12.2 c2.4-3,5.8-4.5,10.1-4.5c3.9,0,7,1.3,9.1,3.8s3.2,6.1,3.2,10.7v25h7.3V76.6C510.7,69.5,509,64.3,505.6,60.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M563.4,56.4H557l-1,7.9c-1.5-2.7-3.6-4.7-6.2-6.2c-2.7-1.4-5.8-2.2-9.5-2.2c-4.2,0-8,1-11.3,3 c-3.4,2-6,4.7-7.9,8.2c-1.9,3.6-2.8,7.6-2.8,12.2c0,4.8,0.9,9,2.8,12.5c1.9,3.6,4.5,6.3,7.8,8.1c3.3,1.9,7.1,2.8,11.4,2.8 c7.2,0,12.4-2.8,15.7-8.4v5.4c0,9.7-4.9,14.4-14.8,14.4c-3.8,0-7-0.7-9.4-2.3c-2.5-1.5-4-3.8-4.6-6.6h-7.5c0.5,5,2.7,8.8,6.4,11.5 c3.8,2.7,8.6,4,14.5,4c15,0,22.6-6.9,22.6-20.7V56.4H563.4z M548.9,94c-2.3,1.4-4.9,2.1-7.8,2.1c-4.6,0-8.2-1.5-11-4.7 c-2.8-3.1-4.1-7.2-4.1-12.2c0-4.9,1.3-8.9,4.1-12.1c2.8-3.1,6.4-4.7,11-4.7c2.9,0,5.5,0.7,7.8,2.1s4.1,3.5,5.4,6.1 c1.3,2.6,1.9,5.5,1.9,8.8s-0.6,6.2-1.9,8.7C553,90.6,551.2,92.6,548.9,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M616.7,39.4h-7.3v24c-1.5-2.3-3.6-4.1-6.2-5.5c-2.7-1.3-5.8-2.1-9.5-2.1c-4.2,0-8,1-11.3,3 c-3.4,2-6,4.7-7.9,8.2c-1.9,3.6-2.8,7.6-2.8,12.2c0,4.8,0.9,9,2.8,12.5c1.9,3.6,4.5,6.3,7.8,8.1c3.3,1.9,7.1,2.8,11.4,2.8 c6.6,0,11.8-2.6,15.7-7.9l1,7.3h6.4V39.4H616.7z M602.2,94c-2.3,1.4-4.9,2.1-7.8,2.1c-4.6,0-8.2-1.5-11-4.7 c-2.8-3.1-4.1-7.2-4.1-12.2c0-4.9,1.3-8.9,4.1-12.1c2.8-3.1,6.4-4.7,11-4.7c2.9,0,5.5,0.7,7.8,2.1s4.1,3.5,5.4,6.1 c1.3,2.6,1.9,5.5,1.9,8.8s-0.6,6.2-1.9,8.7C606.3,90.6,604.5,92.6,602.2,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M635.9,99.6c3.4,2,7.3,3,11.8,3c4.4,0,8.3-1,11.7-3s6.1-4.7,8.1-8.2c1.9-3.5,2.9-7.5,2.9-12.2 c0-4.6-1-8.6-2.9-12.2c-2-3.5-4.7-6.3-8.1-8.2c-3.4-2-7.3-3-11.7-3c-4.5,0-8.4,1-11.8,3c-3.4,2-6.1,4.7-8,8.2 c-2,3.6-2.9,7.6-2.9,12.2c0,4.7,0.9,8.7,2.9,12.2C629.8,95,632.5,97.7,635.9,99.6z M655.6,93.9c-2.3,1.4-4.9,2.1-7.9,2.1 s-5.6-0.7-8-2.1c-2.3-1.4-4-3.4-5.3-6c-1.3-2.5-1.9-5.5-1.9-8.7s0.6-6.1,1.9-8.7c1.3-2.5,3-4.6,5.3-6s4.9-2.1,8-2.1 c3,0,5.5,0.7,7.9,2.1c2.3,1.4,4.1,3.5,5.4,6c1.3,2.6,1.9,5.5,1.9,8.7s-0.6,6.2-1.9,8.7C659.7,90.5,657.9,92.5,655.6,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M742.1,60.7c-3.2-3.2-7.3-4.8-12.4-4.8c-7.3,0-12.6,3-15.8,8.7c-1.3-2.9-3.2-5-5.7-6.4s-5.5-2.2-8.7-2.2 c-5.6,0-10.1,2.3-13.3,6.8l-1-6.3h-6.4v45.6h7.3V78c0-4.6,1.1-8.2,3.2-11.1c2.1-2.9,5.1-4.3,8.9-4.3c3.5,0,6.2,1.2,8.1,3.5 c1.9,2.3,2.9,5.7,2.9,10.1v25.9h7.3V77.7c0-4.7,1.1-8.3,3.2-11c2.1-2.7,5.2-4,9-4c3.4,0,6.1,1.2,8,3.5s2.9,5.7,2.9,10.1v25.9h7.3 V75.9C747,69,745.4,63.9,742.1,60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M762.8,81.6h-7.7c0.2,4.1,1.3,7.8,3.2,11c2,3.2,4.8,5.6,8.5,7.4c3.6,1.8,7.9,2.6,12.8,2.6 c4.3,0,8.1-0.7,11.5-2.3c3.4-1.5,6-3.7,7.9-6.5s2.9-6,2.9-9.6c0-5.5-1.9-9.4-5.6-11.9c-3.8-2.5-8.8-4.3-15-5.4 c-3.9-0.6-7.1-1.3-9.3-2c-2.3-0.7-4.1-1.7-5.5-3s-2.1-3.2-2.1-5.6c0-3.2,1.2-5.8,3.7-7.6c2.4-1.8,5.7-2.8,9.9-2.8 c4.1,0,7.6,1.2,10.5,3.3c2.8,2.2,4.4,5.2,4.9,8.8h7.7c-0.3-3.8-1.3-7.1-3.3-9.9c-2-2.9-4.7-5.2-8.1-6.8c-3.4-1.6-7.3-2.4-11.7-2.4 c-4.2,0-8,0.8-11.2,2.2c-3.2,1.5-5.7,3.7-7.5,6.4c-1.8,2.7-2.7,5.8-2.7,9.3c0,5.5,1.8,9.5,5.5,11.9c3.7,2.5,8.7,4.2,14.9,5.3 c3.9,0.7,7,1.3,9.3,2.1c2.3,0.7,4.2,1.7,5.6,3.1c1.4,1.4,2.2,3.4,2.2,5.8c0,3.4-1.3,6-4,7.9s-6.1,2.8-10.4,2.8 c-4.8,0-8.8-1.3-11.8-3.8C764.8,89.3,763.1,85.9,762.8,81.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M813.8,63.1v27c0,4.1,0.9,7.2,2.7,9c1.8,2,4.9,2.9,9.2,2.9h8.4v-6.7h-8c-1.9,0-3.2-0.4-3.9-1.2 c-0.7-0.8-1.1-2.1-1.1-4.1V63.1h11.5v-6.7h-11.5V43.6h-7.3v12.8h-8.2v6.7H813.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M881.3,95.4h-2.2c-2.1,0-3-1.1-3-3.3V72.4c0-5.3-1.6-9.3-4.8-12.2c-3.2-2.9-7.7-4.3-13.5-4.3 c-5.5,0-10,1.3-13.4,3.8s-5.4,6-5.9,10.5h7.3c0.4-2.3,1.7-4.1,3.8-5.5s4.7-2.1,7.9-2.1c3.6,0,6.4,0.9,8.3,2.5c2,1.7,3,4,3,7v3.1 h-13.4c-6,0-10.6,1.3-13.7,3.7c-3.1,2.5-4.7,6-4.7,10.6c0,4.1,1.5,7.4,4.6,9.8c3,2.4,7.2,3.6,12.3,3.6c6.6,0,11.7-2.5,15.3-7.6 c0,2.3,0.7,4.1,2,5.3c1.3,1.3,3.3,1.8,6.3,1.8h4v-7H881.3z M868.7,81.2v2.2c0,3.9-1.3,7.1-3.8,9.4c-2.6,2.3-6.1,3.5-10.6,3.5 c-3,0-5.5-0.6-7.2-2.1c-1.8-1.3-2.7-3.1-2.7-5.5c0-5,3.4-7.6,10.2-7.6L868.7,81.2L868.7,81.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M910.1,56.4H908c-3.8,0-6.6,0.6-8.7,1.9c-2.1,1.3-3.8,3-5.1,5l-1-6.9H887V102h7.3V78.7 c0-4.3,0.9-7.9,2.8-10.8c1.9-2.9,5-4.4,9.4-4.4h3.7v-7.1H910.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M916.9,43.6v46.5c0,4.1,0.9,7.2,2.7,9c1.8,2,4.9,2.9,9.2,2.9h8.4v-6.7h-8c-1.9,0-3.2-0.4-3.9-1.2 c-0.7-0.8-1.1-2.1-1.1-4.1V63.1h11.5v-6.7h-11.5V43.6H916.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M942.3,67c-1.8,3.6-2.7,7.6-2.7,12.3c0,4.7,0.9,8.7,2.8,12.3s4.6,6.3,8,8.2c3.4,2,7.3,2.9,11.9,2.9 c5.2,0,9.6-1.4,13.2-4.4s5.8-6.8,6.7-11.5h-7.4c-0.8,3-2.3,5.3-4.7,6.9c-2.3,1.6-5.1,2.4-8.3,2.4c-4.3,0-7.7-1.3-10.3-4 c-2.7-2.7-4-6.3-4.1-10.7v-0.6h35.4c0.1-1.4,0.2-2.4,0.2-3.1c-0.2-4.4-1.2-8.2-3-11.5c-1.9-3.2-4.4-5.7-7.6-7.5 c-3.2-1.7-7-2.6-11.1-2.6c-4.3,0-8.1,1-11.3,3C946.7,60.8,944.1,63.5,942.3,67z M975.3,74.6h-27.6c0.4-3.6,1.8-6.5,4.5-8.9 c2.6-2.2,5.6-3.4,9.1-3.4c3.8,0,7.1,1.1,9.6,3.2C973.5,67.7,975,70.7,975.3,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1014.5,56.4h-2.1c-3.8,0-6.6,0.6-8.7,1.9s-3.8,3-5.1,5l-1-6.9h-6.4V102h7.3V78.7c0-4.3,0.9-7.9,2.8-10.8 s5-4.4,9.4-4.4h3.7L1014.5,56.4L1014.5,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.9,0l-1.3,66.9h3.5L371.9,0z M372.7,133.9L374,67h-3.5L372.7,133.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.207,
    y1: 940.1896,
    x2: 54.207,
    y2: 1017.3676,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,9.5h25.6v48.2l45-48.2H104L52.4,63.4l56,62.1H72.7l-47.1-55v55H0V9.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.7063,
    y1: 940.1896,
    x2: 170.7063,
    y2: 1017.3676,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M117.3,9.5h38.3c9.3,0,18.1,1,26.4,3.1s15.6,5.4,21.8,10.1c6.3,4.6,11.1,10.7,14.8,18.1s5.5,16.4,5.5,27 c0,9.4-1.7,17.6-5.3,24.8c-3.6,7.1-8.3,13.1-14.3,18c-6,4.9-13,8.5-20.8,11c-7.8,2.5-16.1,3.7-24.7,3.7h-41.7V9.5L117.3,9.5z  M142.8,101.9h13.3c5.9,0,11.4-0.6,16.4-1.8c5-1.2,9.5-3.2,13.2-6c3.7-2.8,6.6-6.4,8.8-11c2.1-4.5,3.2-10.1,3.2-16.6 c0-5.7-1-10.6-3.2-14.8c-2.1-4.2-5-7.7-8.6-10.4c-3.6-2.7-7.8-4.8-12.7-6.2c-4.9-1.4-10-2.1-15.3-2.1h-15L142.8,101.9L142.8,101.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.4668,
    y1: 940.0937,
    x2: 286.4668,
    y2: 1017.0956,
    gradientTransform: "matrix(1 0 0 1 0 -891.8677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F88F56"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F26E55"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M339.2,114.6c-7.1,3.7-14.7,6.4-22.4,8.1c-7.8,1.7-15.7,2.5-23.8,2.5c-8.6,0-16.6-1.4-23.8-4 c-7.3-2.7-13.6-6.5-18.9-11.6c-5.3-5-9.5-11.1-12.4-18.3c-3-7.1-4.4-15.1-4.4-23.9s1.5-16.8,4.4-23.9s7.1-13.2,12.4-18.3 c5.3-5,11.6-8.9,18.9-11.6s15.2-4,23.9-4c8.9,0,17,1,24.4,3.2c7.4,2.1,14,5.7,19.6,11l-17.1,18.7c-3.3-3.4-7-6-11.2-7.7 c-4.2-1.7-9.4-2.6-15.6-2.6c-5.2,0-9.9,0.9-14.1,2.6c-4.2,1.7-7.8,4.3-10.9,7.4c-3,3.1-5.3,7-7,11.3c-1.7,4.3-2.4,9-2.4,14.2 c0,5.2,0.8,9.9,2.4,14.3c1.7,4.3,3.9,8,7,11.2c3,3.1,6.6,5.7,10.9,7.4c4.2,1.7,9,2.6,14.1,2.6c5.3,0,9.9-0.6,13.7-1.8 c3.8-1.2,7-2.4,9.2-3.7V79.8h-19.8V57.2h43.2v57.5H339.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKdg);
export default __webpack_public_path__ + "static/media/KDG.0324386ddbe3e9e316eb9a4d06a5b511.svg";
export { ForwardRef as ReactComponent };